import { uniqueId } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Agro1Loader: Agro1LoaderType = () => {
  const [activeLoaderIds, setActiveLoaderIds] = useState<string[]>([]);
  const visible = activeLoaderIds.length > 0;

  useEffect(() => {
    Agro1Loader.close = (id) => {
      setActiveLoaderIds((prevIds) =>
        prevIds.filter((prevId) => prevId !== id),
      );
    };

    Agro1Loader.show = (id = uniqueId('agro1_loader_')) => {
      setActiveLoaderIds((prevIds) => [...prevIds, id]);

      return id;
    };
  }, []);

  if (!visible) return null;

  return (
    <>
      {createPortal(
        <div className="agro1-loader align-items-center">
          <div className="icons">
            <i className="icon-loaders loader-machine" />
            <i className="icon-loaderm loader-wheel" />
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

Agro1Loader.show = () => {
  throw new Error('Agro1Loader não inicializado.');
};

Agro1Loader.close = () => {
  throw new Error('Agro1Loader não inicializado.');
};

interface Agro1LoaderType extends FC {
  show: (id?: string) => string;
  close: (id: string) => void;
}

export default Agro1Loader;
